import styles from './TypingIndicator.module.css';

export function TypingIndicator() {
  return (
    <div className={styles.typingIndicator}>
      <div className={styles.dots}>
        <span className={styles.dot}></span>
        <span className={styles.dot}></span>
        <span className={styles.dot}></span>
      </div>
    </div>
  );
}
